// Products
export const PRODUCTS_SET = "products/set";
export const PRODUCTS_SET_ERROR = "products/setError";
export const PRODUCTS_IS_LOADING = "products/isLoading";

// Cart
export const CART_PUSH_CURRENT_ITEM = "cart/pushItemCart";
export const CART_SET = "cart/setItems";
export const CART_SET_REMOVE_ITEM = "cart/removeItem";
export const CART_CLEAR = "cart/clear";
export const CART_CLEAR_CURRENT = "cart/clearCurrent";
export const CART_UPDATE_STORAGE = "cart/updateStorage";
export const CART_SET_CURRENT_ITEM = "cart/setCurrentItem";
export const CART_SET_CURRENT_STEP = "cart/setCurrentStep";
export const CART_SET_SUBSCRIBER = "cart/setSubscriber";
export const CART_SET_DELIVERY_STATUS = "cart/setDeliveryStatus";

// User
export const USER_SITE_MODE = "user/siteMode";
export const USER_RESET_AUTH = "user/resetAuth";
export const USER_PURGE = "user/logOut";
export const USER_SET = "user/setUser";
export const USER_RESET = "user/resetUser";
export const USER_SET_ERROR = "user/setError";
export const USER_SET_MESSAGE = "user/setMessage";
export const USER_SET_AUTH_STATE = "user/setAuthState";

// Session, not namespaced
export const PURGE_SESSION_KEY = "deleteSessionKey";
export const SET_SESSION_KEY = "setSessionKey";
export const SET_ERROR = "setError";
export const IS_LOADING = "isLoading";

// Coverage Map
export const COVERAGE_SET = "coverage/set";
export const PLACE_SET = "coverage/placeSet";
export const COVERAGE_IS_LOADING = "coverage/is_loading";
export const COVERAGE_SET_ERRORS = "coverage/set_errors";